"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SelectManager_eventEngine, _SelectManager_logger, _SelectManager_tree, _SelectManager_deselectOnEmpty, _SelectManager_filter, _SelectManager_groupInteractionEffectToken, _SelectManager_groupedNodes, _SelectManager_interactionEffectToken, _SelectManager_intersection, _SelectManager_keyPressed, _SelectManager_node, _SelectManager_removalKey, _SelectManager_selectOn;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectManager = void 0;
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const IInteractionEngine_1 = require("../../interfaces/IInteractionEngine");
const AbstractInteractionManager_1 = require("../AbstractInteractionManager");
const InteractionManagerUtils_1 = require("../utils/InteractionManagerUtils");
/* eslint-disable @typescript-eslint/no-unused-vars */
class SelectManager extends AbstractInteractionManager_1.AbstractInteractionManager {
    constructor(id, interactionEffect, deselectOnEmpty, selectOn = "down") {
        super(id, interactionEffect);
        _SelectManager_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _SelectManager_logger.set(this, viewer_shared_services_1.Logger.instance);
        _SelectManager_tree.set(this, viewer_shared_node_tree_1.Tree.instance);
        _SelectManager_deselectOnEmpty.set(this, false);
        _SelectManager_filter.set(this, void 0);
        _SelectManager_groupInteractionEffectToken.set(this, void 0);
        _SelectManager_groupedNodes.set(this, void 0);
        _SelectManager_interactionEffectToken.set(this, void 0);
        _SelectManager_intersection.set(this, null);
        _SelectManager_keyPressed.set(this, {
            removal: false,
        });
        _SelectManager_node.set(this, null);
        _SelectManager_removalKey.set(this, "Control");
        _SelectManager_selectOn.set(this, void 0);
        if (deselectOnEmpty !== undefined)
            __classPrivateFieldSet(this, _SelectManager_deselectOnEmpty, deselectOnEmpty, "f");
        __classPrivateFieldSet(this, _SelectManager_selectOn, selectOn, "f");
        __classPrivateFieldSet(this, _SelectManager_filter, InteractionManagerUtils_1.InteractionManagerUtils.createInteractionFilter("select", this.id, [
            __classPrivateFieldGet(this, _SelectManager_selectOn, "f") === "down"
                ? IInteractionEngine_1.INTERACTION_STATE.DOWN
                : IInteractionEngine_1.INTERACTION_STATE.UP,
        ]), "f");
    }
    get deselectOnEmpty() {
        return __classPrivateFieldGet(this, _SelectManager_deselectOnEmpty, "f");
    }
    set deselectOnEmpty(value) {
        __classPrivateFieldSet(this, _SelectManager_deselectOnEmpty, value, "f");
    }
    get filter() {
        return __classPrivateFieldGet(this, _SelectManager_filter, "f");
    }
    get removalKey() {
        return __classPrivateFieldGet(this, _SelectManager_removalKey, "f");
    }
    set removalKey(value) {
        __classPrivateFieldSet(this, _SelectManager_removalKey, value, "f");
    }
    add(viewport) {
        this.viewport = viewport;
    }
    /**
     * Deselect the current node.
     */
    deselect() {
        if (__classPrivateFieldGet(this, _SelectManager_node, "f"))
            this.deactivateNode();
    }
    onDown(event, ray, intersection) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _SelectManager_logger, "f")))
            return;
        if (__classPrivateFieldGet(this, _SelectManager_selectOn, "f") === "down") {
            const intersections = intersection.filter((i) => this.filter(IInteractionEngine_1.INTERACTION_STATE.DOWN)(i.node) &&
                i.type === "RayTracingIntersection");
            this.handleIntersection(event, ray, intersections);
        }
    }
    onEnd(event, ray, intersection, endState) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _SelectManager_logger, "f")))
            return;
        if (__classPrivateFieldGet(this, _SelectManager_selectOn, "f") === "up") {
            const intersections = intersection.filter((i) => this.filter(IInteractionEngine_1.INTERACTION_STATE.UP)(i.node) &&
                i.type === "RayTracingIntersection");
            this.handleIntersection(event, ray, intersections);
        }
    }
    onKeyDown(event, pointerInCanvas) {
        if (event.key === __classPrivateFieldGet(this, _SelectManager_removalKey, "f"))
            __classPrivateFieldGet(this, _SelectManager_keyPressed, "f").removal = true;
    }
    onKeyUp(event, pointerInCanvas) {
        if (event.key === __classPrivateFieldGet(this, _SelectManager_removalKey, "f"))
            __classPrivateFieldGet(this, _SelectManager_keyPressed, "f").removal = false;
    }
    onMove(event, ray, intersection) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _SelectManager_logger, "f")))
            return;
    }
    remove() {
        if (__classPrivateFieldGet(this, _SelectManager_node, "f"))
            this.deactivateNode();
        this.viewport = undefined;
    }
    /**
     * Select a node.
     * The point and distance of the intersection can be freely chosen and are provided in the event callbacks.
     *
     * @param intersection
     */
    select(intersection) {
        if (__classPrivateFieldGet(this, _SelectManager_node, "f"))
            this.deactivateNode(undefined, true);
        this.activateNode(Object.assign(Object.assign({}, intersection), { type: "RayTracingIntersection" }));
    }
    /**
     * Utility function to make the node the current active node.
     * Set the according values, apply the effect and emit the event.
     *
     * @param intersection
     * @param event
     * @param ray
     */
    activateNode(intersection, event, ray) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _SelectManager_logger, "f")))
            return;
        __classPrivateFieldSet(this, _SelectManager_intersection, intersection, "f");
        __classPrivateFieldSet(this, _SelectManager_node, __classPrivateFieldGet(this, _SelectManager_intersection, "f").node, "f");
        __classPrivateFieldSet(this, _SelectManager_groupedNodes, undefined, "f");
        __classPrivateFieldSet(this, _SelectManager_groupInteractionEffectToken, undefined, "f");
        // find the interaction data
        const data = InteractionManagerUtils_1.InteractionManagerUtils.getInteractionData(__classPrivateFieldGet(this, _SelectManager_node, "f"), true, this.id, "select");
        if (data)
            data.interactionStates.select = true;
        // find and store all nodes that are within the group
        if (data && data.groupId) {
            __classPrivateFieldSet(this, _SelectManager_groupedNodes, this.gatheredGroupedNodes[data.groupId] || [], "f");
            __classPrivateFieldSet(this, _SelectManager_groupInteractionEffectToken, [], "f");
        }
        // apply the effect material if there is something to apply
        const { token, groupTokens } = InteractionManagerUtils_1.InteractionManagerUtils.applyInteractionEffects(__classPrivateFieldGet(this, _SelectManager_node, "f"), __classPrivateFieldGet(this, _SelectManager_groupedNodes, "f"), this.interactionEffect, this.interactionEffectUtils);
        __classPrivateFieldSet(this, _SelectManager_interactionEffectToken, token, "f");
        __classPrivateFieldSet(this, _SelectManager_groupInteractionEffectToken, groupTokens, "f");
        InteractionManagerUtils_1.InteractionManagerUtils.updateViewport(this.viewport, __classPrivateFieldGet(this, _SelectManager_node, "f"), __classPrivateFieldGet(this, _SelectManager_groupedNodes, "f"));
        __classPrivateFieldGet(this, _SelectManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.SELECT_ON, {
            viewportId: this.viewport.id,
            node: __classPrivateFieldGet(this, _SelectManager_node, "f"),
            intersectionPoint: __classPrivateFieldGet(this, _SelectManager_intersection, "f").type === "RayTracingIntersection"
                ? __classPrivateFieldGet(this, _SelectManager_intersection, "f").point
                : undefined,
            ray,
            event,
            manager: this,
            groupedNodes: __classPrivateFieldGet(this, _SelectManager_groupedNodes, "f"),
        });
    }
    /**
     * Utility function to make the node inactive.
     * Set the according values, remove the effect and emit the event.
     *
     * @param event
     */
    deactivateNode(event, reselection = false) {
        const viewportOk = InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _SelectManager_logger, "f"));
        if (!viewportOk) {
            return;
        }
        // find the interaction data
        const data = InteractionManagerUtils_1.InteractionManagerUtils.getInteractionData(__classPrivateFieldGet(this, _SelectManager_node, "f"), true, this.id, "select");
        if (data)
            data.interactionStates.select = false;
        InteractionManagerUtils_1.InteractionManagerUtils.removeInteractionEffects(__classPrivateFieldGet(this, _SelectManager_node, "f"), __classPrivateFieldGet(this, _SelectManager_groupedNodes, "f"), __classPrivateFieldGet(this, _SelectManager_interactionEffectToken, "f"), __classPrivateFieldGet(this, _SelectManager_groupInteractionEffectToken, "f") || [], this.interactionEffectUtils);
        __classPrivateFieldSet(this, _SelectManager_interactionEffectToken, undefined, "f");
        __classPrivateFieldSet(this, _SelectManager_groupInteractionEffectToken, undefined, "f");
        InteractionManagerUtils_1.InteractionManagerUtils.updateViewport(this.viewport, __classPrivateFieldGet(this, _SelectManager_node, "f"), __classPrivateFieldGet(this, _SelectManager_groupedNodes, "f"));
        __classPrivateFieldGet(this, _SelectManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.SELECT_OFF, {
            viewportId: this.viewport.id,
            node: __classPrivateFieldGet(this, _SelectManager_node, "f"),
            event,
            manager: this,
            groupedNodes: __classPrivateFieldGet(this, _SelectManager_groupedNodes, "f"),
            reselection,
        });
        __classPrivateFieldSet(this, _SelectManager_intersection, null, "f");
        __classPrivateFieldSet(this, _SelectManager_node, null, "f");
        __classPrivateFieldSet(this, _SelectManager_groupedNodes, undefined, "f");
        __classPrivateFieldSet(this, _SelectManager_groupInteractionEffectToken, undefined, "f");
    }
    handleIntersection(event, ray, intersections) {
        // create a list that replaces all irrelevant intersections with null
        const filteredIntersections = intersections.map((i) => {
            return InteractionManagerUtils_1.InteractionManagerUtils.getInteractionData(i.node, true, this.id, "select")
                ? i
                : null;
        });
        const firstIntersection = filteredIntersections.length > 0 ? filteredIntersections[0] : null;
        if (__classPrivateFieldGet(this, _SelectManager_node, "f")) {
            if (firstIntersection && firstIntersection.node !== __classPrivateFieldGet(this, _SelectManager_node, "f")) {
                // case other node was clicked, deselect then select
                this.deactivateNode(event);
                if (!__classPrivateFieldGet(this, _SelectManager_keyPressed, "f").removal)
                    this.activateNode(firstIntersection, event, ray);
            }
            else if (firstIntersection &&
                firstIntersection.node === __classPrivateFieldGet(this, _SelectManager_node, "f")) {
                // case same node was clicked, only deselect
                this.deactivateNode(event);
            }
            else if (!firstIntersection && __classPrivateFieldGet(this, _SelectManager_deselectOnEmpty, "f")) {
                // case no node was clicked, only deselect when option is on
                this.deactivateNode(event);
            }
        }
        else if (firstIntersection && !__classPrivateFieldGet(this, _SelectManager_keyPressed, "f").removal) {
            // easy case, no node select, just select this one
            this.activateNode(firstIntersection, event, ray);
        }
    }
}
exports.SelectManager = SelectManager;
_SelectManager_eventEngine = new WeakMap(), _SelectManager_logger = new WeakMap(), _SelectManager_tree = new WeakMap(), _SelectManager_deselectOnEmpty = new WeakMap(), _SelectManager_filter = new WeakMap(), _SelectManager_groupInteractionEffectToken = new WeakMap(), _SelectManager_groupedNodes = new WeakMap(), _SelectManager_interactionEffectToken = new WeakMap(), _SelectManager_intersection = new WeakMap(), _SelectManager_keyPressed = new WeakMap(), _SelectManager_node = new WeakMap(), _SelectManager_removalKey = new WeakMap(), _SelectManager_selectOn = new WeakMap();
//# sourceMappingURL=SelectManager.js.map